var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1140 237.72v146.28-146.28c-0.035156-29.352-7.418-58.23-21.48-84 14.062 25.77 21.445 54.648 21.48 84z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1118.3 153.24c-8.2695-14.98-18.566-28.75-30.602-40.918-16.23-16.129-35.367-29.035-56.398-38.039-21.77-9.3438-45.195-14.199-68.883-14.281h-724.8c-47.086 0.0625-92.223 18.797-125.51 52.09-33.293 33.289-52.027 78.426-52.09 125.51v724.8c0.0625 47.086 18.797 92.223 52.09 125.51 33.289 33.293 78.426 52.027 125.51 52.09h724.8c47.086-0.0625 92.223-18.797 125.51-52.09 33.293-33.289 52.027-78.426 52.09-125.51v-724.8c-0.0625-29.496-7.5312-58.504-21.719-84.363zm-50.281 809.16c0.03125 28.02-11.082 54.898-30.895 74.707-19.809 19.812-46.688 30.926-74.707 30.895h-724.8c-28.02 0.03125-54.898-11.082-74.707-30.895-19.812-19.809-30.926-46.688-30.895-74.707v-578.4h936z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m292.56 736.32h297.84c19.352 0 35.039 19.352 35.039 35.039v9.9609c0 19.352-15.688 35.039-35.039 35.039h-297.84c-19.352 0-35.039-19.352-35.039-35.039v-9.9609c0-19.352 15.688-35.039 35.039-35.039z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m292.56 599.4h614.88c19.352 0 35.039 19.352 35.039 35.039v9.9609c0 19.352-15.688 35.039-35.039 35.039h-614.88c-19.352 0-35.039-19.352-35.039-35.039v-9.9609c0-19.352 15.688-35.039 35.039-35.039z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6acbdf735eda9829cc6556192a1ac222.svg";
export { ForwardRef as ReactComponent };